import CONFIG from '../config/config';
import { instanceWithV2 as instance } from './SimpleAPIClient';

const CommissionContractAliasAPI = {
  getAlias: () => {
    return instance(CONFIG.API_ENDPOINT).get<string>('v1/commission-contracts/alias');
  },
  setAlias: (alias: string) => {
    return instance(CONFIG.API_ENDPOINT).post<string>('v1/commission-contracts/alias', { alias });
  },
  checkAliasAvailability: (alias: string, signal?: AbortSignal) => {
    return instance(CONFIG.API_ENDPOINT).post<string>('v1/commission-contracts/alias/check', { alias }, { signal });
  },
};

export default CommissionContractAliasAPI; 